// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11COP","name":"styles_name__3votJ","phone":"styles_phone__4y5RG"};